/* eslint-disable react/destructuring-assignment */
import React from "react"
import { useSelector } from "react-redux"

import {
    OPEN,
    VERIFICATION,
    APPROVED,
    YES,
} from "const"
import { CcResponse } from "server/models"
import {
    StoreType,
    CcResponseList,
    LangType,
} from "client/store"
import {
    HistoryProps,
    HistoryType,
    ArrowIcon,
} from "client/components"
import {
    Status,
    Bold,
} from "./styled"

const getStatus = (response: CcResponse, status: string, lang: LangType) => {
    switch (status) {
        case OPEN:
            return lang.open
        case VERIFICATION:
            return lang.verification
        case APPROVED:
            if (response && response.approved === YES) return lang.approved
            return lang.notApproved
        default:
            return status
    }
}

export const HistoryStatus = ({
    history,
}: HistoryProps) => {
    const responseList = useSelector((state: StoreType) => state.ccResponse.responseList)
    const lang = useSelector((state: StoreType) => state.system.lang)

    const response = responseList[history.responseId]
    const prevStatus = getStatus(response, history.prevStatus, lang)
    const nextStatus = getStatus(response, history.nextStatus, lang)

    if (!prevStatus || !nextStatus) return null
    return (
        <Status>
            <Bold>{`${lang.status}:`}</Bold>
            <span>
                {prevStatus}
                <ArrowIcon />
                {nextStatus}
            </span>
        </Status>
    )
}

export const HistoryStatusPdfExport = (
    history: HistoryType,
    responseList: CcResponseList,
    lang: LangType,
) => {
    const response = responseList[history.responseId]
    const prevStatus = getStatus(response, history.prevStatus, lang)
    const nextStatus = getStatus(response, history.nextStatus, lang)

    if (!prevStatus || !nextStatus) return null
    return ({
        text: [
            {
                text: `${lang.status}: `,
                bold: true,
            },
            { text: `${prevStatus} —> ${nextStatus}` },
        ],
        margin: [0, 0, 0, 5],
    })
}
